// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--0rbro";
export var checkbox__box = "checkbox-module--checkbox__box--75bHc";
export var checkbox__icon = "checkbox-module--checkbox__icon--Sb-RY";
export var checkbox__check = "checkbox-module--checkbox__check--jSaCr";
export var checkbox__label = "checkbox-module--checkbox__label--Bs-MB";